// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-i_hx","catalogByServiceItem__title":"c-i_hy"};